import MuiRadioGroup, { RadioGroupProps } from '@mui/material/RadioGroup';
import FormControl from '../FormControl';
import FormHelperText from '../FormHelperText';
import FormLabel from '../FormLabel';
import Fieldset from "../Fieldset";
import { helper } from "src/utils/helper";

export interface IRadioGroupProps extends RadioGroupProps {
  helperText?: string;
  id: string;
  error?: boolean;
  label?: string;
  fullWidth?: boolean;
  onChange?: (event: { target: { name: string, value: any } }, value: any) => void;
};

const RadioGroup = (props: IRadioGroupProps): JSX.Element => {
  const { label, error, helperText, ...rest } = props;
  return (
    <FormControl error={Boolean(error)} fullWidth={props.fullWidth === false ? props.fullWidth : true} size="small">
      <Fieldset label={label ? true : ""}>
        {label && (
          <legend>
            <FormLabel sx={{ fontSize: 14 }} id={"label" + props.id}>{label}</FormLabel>
          </legend>
        )}
        <MuiRadioGroup
          {...rest}
          sx={{
            padding: 0,
            margin: label ? "-17px 0px -16px 0px" : "-10px 0px -10px 0px"
          }}
          row={props.row === false ? false : true}
          aria-labelledby={"label" + props.id}
          onChange={(e, v) => {
            if (props.onChange) {
              let val = v as any;
              if (typeof props.value === "number")
                val = helper.objectToNumber(v)
              props.onChange({
                target: {
                  name: props.name,
                  value: val
                }
              }, v)
            }
          }}
          value={props.value ?? ""}
        />
      </Fieldset>
      {helperText && <FormHelperText error={Boolean(error)}>{helperText}</FormHelperText>}
    </FormControl>
  );
};
export default RadioGroup;